module.exports = __webpack_public_path__ + "img/floor_UG2.92a8d9a8.svg";